<template>
  <body class="bg-navy text-white overflow-x-hidden">
    <nav class="fixed w-full z-50 bg-navy/90 backdrop-blur-sm border-b border-gray-800">
      <div class="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <div class="font-bold tracking-tighter flex items-center gap-2" style="width: 20rem">
          <a href="https://consumerinsearch.com/">
            <b-img src="https://consumerinsearch.com/files/attach/images/109/2148391c1acb195c367a7c5a131516fe.png" alt="" class="logo_img_dark" width="auto" style="margin: 0px"/>
          </a>
        </div>
        <div class="max-w-3xl md:flex gap-4 text-lg font-medium text-gray-600 transition">
          <a href="https://consumerinsearch.com/report" target="_blank" class="hover:text-black text-lg font-bold transition" style="color: darkgray;">CIS리포트</a>
          <a href="https://consumerinsearch.com/notice" target="_blank" class="hover:text-black text-lg font-bold transition" style="color: darkgray;">공지사항</a>
        </div>
        <a href="/login" class="px-5 py-2 neon-bg text-white font-bold rounded hover:opacity-90 transition">CIS 서비스로 바로가기</a>
        <!-- <a href="/vote2026t" target="_blank" class="px-5 py-2 text-white font-bold rounded hover:opacity-90 transition" style="background-color: lightslategray; margin-left: -90px;">2026 지방선거 서비스로 바로가기</a> 
        <div class="bubble_t p-1 font-bold" style="background-color: #28c76f; backdrop-filter: blur(3px); border: 1px solid #28c76f; font-family: Verdana, sans-serif; font-size: 8px; margin-left: -90px; margin-bottom: 20px;"><i>βeta!</i></div> -->
      </div>
    </nav>

    <header class="relative pt-32 pb-10 lg:pt-48 lg:pb-32 px-6 text-center">
      <div class="max-w-5xl mx-auto">
        <p class="text-gray-800 text-lg mb-4 tracking-widest uppercase">The New Standard of Search Intelligence</p>
        <h1 class="text-4xl md:text-6xl lg:text-7xl font-black mb-6 leading-tight text-gray-800">
          Minimize <span class="text-gray-400">hesitation</span><br>
          Maximize <span class="neon-text">acceleration</span>
        </h1>
        <p class="text-xl md:text-2xl text-gray-800 mb-10 font-light">
          단순한 정보 너머, <strong class="text-black">실행을 위한 최적의 통찰</strong>을 제공합니다.<br>
          이제 고민은 줄이고 성과는 가속화하세요.
        </p>
        <div class="flex flex-col md:flex-row justify-center gap-4">
          <a href="https://consumerinsearch.com/#section6" target="_blank" class="px-8 py-4 neon-bg text-white font-bold text-lg rounded hover:opacity-90 transition">무료 체험 신청하기</a>
          <a href="https://consumerinsearch.com/qna" target="_blank" class="px-8 py-4 neon-bg text-white font-bold text-lg rounded hover:opacity-90 transition">서비스 소개서 다운로드</a>
        </div>
        <!-- <div class="flex flex-col md:flex-row justify-center gap-2 mt-2 align-items-center">
          <div class="bubble p-1 font-bold" style="background-color: #28c76f; backdrop-filter: blur(3px); border: 1px solid #28c76f; font-family: Verdana, sans-serif; font-size: 9px;">βeta</div>
          <a href="/vote2026t" class="px-8 py-4 text-white text-lg font-bold rounded hover:opacity-90 transition" style="background-color: lightslategray;">2026 지방선거 서비스로 바로가기</a>
        </div> -->
      </div>
    </header>

    <section id="insights" class="py-20 bg-gray-200/50">
      <div class="max-w-7xl mx-auto px-6">
        <div class="flex justify-between items-end mb-10">
          <div>
            <h2 class="text-3xl font-bold mb-2 text-black">HOT Issue 🔥</h2>
            <!-- <p class="text-gray-800">실시간 검색량 상승율 TOP 5 및 AI 요약 정보 제공 (클릭 시 AI 요약 정보를 볼 수 있습니다.)</p> -->
             <p class="text-gray-800">실시간 검색량 상승율 TOP 5 및 AI 요약 정보 제공</p>
          </div>
          <div class="text-sm text-gray-700 text-right">
            기간: {{ this.period }}<br>주간 검색량 상승율 최다 (전 주 대비)
          </div>
        </div>

        <div class="grid md:grid-cols-3 gap-6">
          <div class="glass-panel p-6 rounded-xl">
            <h3 class="text-xl font-bold mb-4 border-b border-gray-700 pb-2 text-black">HOT 카테고리</h3>
            <div id="loadingCat" class="text-center text-secondary" style="position: absolute; bottom: 8%; left: 40%; visibility: visible;">
              <b-spinner small class="align-middle mr-2"></b-spinner>
              <strong>loaing...</strong>
            </div>
            <ul id="tableCat" class="space-y-4" style="visibility: hidden;">
              <li v-if="this.hot_cat_top_nm == 'empty'" class="flex justify-between items-center"><span class="text-lg text-gray-400">No Data...</span></li>
              <li v-else class="flex justify-between items-center"><span class="text-lg text-black">{{ this.hot_cat_top_nm }}</span> <span class="neon-text font-bold">{{ this.hot_cat_top_rate }}</span></li>
              <li class="flex justify-between items-center" v-for="object in hot_cat_others">
                <span class="text-gray-600">{{ object.rank }}. {{ object.cat_nm }}</span> <span class="text-gray-500 font-bold" style="font-size: 13px;">+{{ object.rate }}%</span>
              </li>
            </ul>
          </div>
          <div class="glass-panel p-6 rounded-xl">
            <h3 class="text-xl font-bold mb-4 border-b border-gray-700 pb-2 text-black">HOT 브랜드 (카테고리)</h3>
            <div id="loadingBrand" class="text-center text-secondary" style="position: absolute; bottom: 8%; left: 40%; visibility: visible;">
              <b-spinner small class="align-middle mr-2"></b-spinner>
              <strong>loaing...</strong>
            </div>
            <ul id="tableBrand" class="space-y-4" style="visibility: hidden;">
              <li v-if="this.hot_brand_top_nm == 'empty'" class="flex justify-between items-center"><span class="text-lg text-gray-400">No Data...</span></li>
              <li v-else class="flex justify-between items-center"><span class="text-lg text-black">{{ this.hot_brand_top_nm }} {{ this.hot_brand_top_cat_nm }}</span> <span class="neon-text font-bold">{{ this.hot_brand_top_rate }}</span></li>
              <li class="flex justify-between items-center" v-for="object in hot_brand_others">
                <span class="text-gray-600">{{ object.rank }}. {{ object.brand }} ({{ object.cat_nm }})</span> <span class="text-gray-500 font-bold" style="font-size: 13px;">+{{ object.rate }}%</span>
              </li>
            </ul>
          </div>
          <div class="glass-panel p-6 rounded-xl">
            <h3 class="text-xl font-bold mb-4 border-b border-gray-700 pb-2 text-black">HOT 속성 (카테고리)</h3>
            <div id="loadingProp" class="text-center text-secondary" style="position: absolute; bottom: 8%; left: 40%; visibility: visible;">
              <b-spinner small class="align-middle mr-2"></b-spinner>
              <strong>loaing...</strong>
            </div>
            <ul id="tableProp" class="space-y-4" style="visibility: hidden;">
              <li v-if="this.hot_prop_top_nm == 'empty'" class="flex justify-between items-center"><span class="text-lg text-gray-400">No Data...</span></li>
              <li v-else class="flex justify-between items-center"><span class="text-lg text-black">{{ this.hot_prop_top_nm }} {{ this.hot_prop_top_cat_nm }}</span> <span class="neon-text font-bold">{{ this.hot_prop_top_rate }}</span></li>
              <li class="flex justify-between items-center" v-for="object in hot_prop_others">
                <span class="text-gray-600">{{ object.rank }}. {{ object.prop }} ({{ object.cat_nm }})</span> <span class="text-gray-500 font-bold" style="font-size: 13px;">+{{ object.rate }}%</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section id="features" class="py-24 px-6">
      <div class="max-w-7xl mx-auto space-y-32">      
        <div class="flex flex-col md:flex-row items-center gap-12">
          <div class="md:w-1/2">
            <!-- <div class="inline-block px-3 py-1 mb-4 border neon-border neon-text text-sm rounded-full">Pain Point 01</div> -->
            <h2 class="text-3xl md:text-4xl font-bold mb-6 text-black">아직도 쿼리를 하나씩<br>입력하고 계신가요?</h2>
            <p class="text-gray-600 text-lg mb-8 leading-relaxed">
              실수로 누락되거나, 담당자마다 다른 쿼리를 사용하면 데이터의 일관성이 떨어집니다.
              <br><br>
              <strong class="text-black">Solution:</strong><br>
              카테고리만 선택하세요. 카테고리에 속한 수 만 개의 키워드를 <span class="neon-text font-bold">단 한 번의 클릭으로 즉시 분석</span>해 드립니다.
            </p>
          </div>
          <div class="md:w-1/2 glass-panel p-1 rounded-xl shadow-2xl">
            <div class="bg-gray-500 rounded-lg aspect-video flex items-center justify-center" style="padding: 5px;">
              <b-img src="@/assets/images/intro/cis_1.jpg" alt="" width="auto" style="margin: 0px"/>
            </div>
          </div>
        </div>

        <div class="flex flex-col md:flex-row-reverse items-center gap-12">
          <div class="md:w-1/2">
            <!-- <div class="inline-block px-3 py-1 mb-4 border neon-border neon-text text-sm rounded-full">Pain Point 02</div> -->
            <h2 class="text-3xl md:text-4xl font-bold mb-6 text-black">핵심 내용이 한 눈에!<br>AI 자동 분류 시스템</h2>
            <p class="text-gray-600 text-lg mb-8 leading-relaxed">
              매번 직접 분류하느라 결과 확인까지 너무 오래 걸리셨나요?<br>
              실수로 잘못 분류하거나, 조직 내에서도 담당자 마다 분류기준이 다를 수 있습니다.
              <br><br>
              <strong class="text-black">Solution:</strong><br>
              소비자 분석 전문가의 노하우를 학습한 AI가 <span class="neon-text font-bold">더 정확하고 빠르게 브랜드를 분류</span>하고 시각화합니다.
            </p>
          </div>

          <div class="md:w-1/2 glass-panel p-1 rounded-xl shadow-2xl">
            <div class="bg-gray-500 rounded-lg aspect-video flex items-center justify-center" style="padding: 5px;">
              <b-img src="@/assets/images/intro/cis_2.jpg" alt="" width="auto" style="margin: 0px"/>
            </div>
          </div>
        </div>

        <div class="flex flex-col md:flex-row items-center gap-12">
          <div class="md:w-1/2">
            <!-- <div class="inline-block px-3 py-1 mb-4 border neon-border neon-text text-sm rounded-full ">Pain Point 03</div> -->
            <h2 class="text-3xl md:text-4xl font-bold mb-6 text-black">급상승한 이유,<br>화면에서 바로 확인하세요.</h2>
            <p class="text-gray-600 text-lg mb-8 leading-relaxed">
              트래픽, 검색량이 튀었는데 이유를 찾느라 시간을 허비하고 계시진 않나요?<br>
              기회도, 위기도 골든타임이 있습니다.
              <br><br>
              <strong class="text-black">Solution:</strong><br>
              이슈가 발생한 키워드를 클릭하세요. <span class="neon-text font-bold">관련 뉴스와 이슈를 팝업으로 즉시 제공</span>하여 빠르고 효과적으로 대응할 수 있습니다.
            </p>
          </div>

          <div class="md:w-1/2 glass-panel p-1 rounded-xl shadow-2xl">
            <div class="bg-gray-500 rounded-lg aspect-video flex items-center justify-center" style="padding: 5px;">
              <b-img src="@/assets/images/intro/cis_3.jpg" alt="" width="auto" style="margin: 0px"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="process" class="py-24 bg-gradient-to-b from-navy to-black">
      <div class="max-w-6xl mx-auto px-6 text-center">
        <h2 class="text-3xl md:text-5xl font-bold mb-6 text-black">AI시대, 모든 마케터를 돕는<br>서치 인텔리전스</h2>
        <p class="text-gray-400 text-xl mb-16">
          B2C 기업, 유통 및 커머스, 광고대행사 등 어느 분야에서도<br>
          마케터의 고민을 정확하고 빠르게 해결합니다.
        </p>

        <div class="grid md:grid-cols-3 gap-8 text-left">
          <div class="bg-gray-100 p-8 rounded-2xl hover:-translate-y-2 transition duration-300">
            <div class="w-12 h-12 neon-bg rounded-lg mb-6 flex items-center justify-center text-black text-2xl">📊</div>
            <h3 class="text-2xl font-bold mb-4 text-black">트렌드 파악</h3>
            <p class="text-gray-600 mb-6">"트렌드를 빠르게 예측하고 대응할 수 있는 정확한 솔루션이 없을까요?"</p>
            <div class="text-sm border-t border-gray-700 pt-4 text-black">
              <span class="neon-text font-bold">Case.</span> '친환경 패키징' 검색량 증가 <br>👉 ESG 캠페인 기획
            </div>
          </div>

          <div class="bg-gray-100 p-8 rounded-2xl hover:-translate-y-2 transition duration-300">
            <div class="w-12 h-12 neon-bg rounded-lg mb-6 flex items-center justify-center text-black text-2xl">🧩</div>
            <h3 class="text-2xl font-bold mb-4 text-black">고객 이해</h3>
            <p class="text-gray-600 mb-6">"소비자가 가진 문제를 객관적으로 측정하는 신뢰할 수 있는 솔루션."</p>
            <div class="text-sm border-t border-gray-700 pt-4 text-black">
              <span class="neon-text font-bold">Case.</span> '제로슈거 음료' 검색량 상승 <br>👉 신제품 라인업 강화
            </div>
          </div>

          <div class="bg-gray-100 p-8 rounded-2xl hover:-translate-y-2 transition duration-300">
            <div class="w-12 h-12 neon-bg rounded-lg mb-6 flex items-center justify-center text-black text-2xl">🎯</div>
            <h3 class="text-2xl font-bold mb-4 text-black">시장 반응 평가</h3>
            <p class="text-gray-600 mb-6">"소비자 반응을 제대로 이해하면서, 결과를 빠르게 볼 수 있습니다."</p>
            <div class="text-sm border-t border-gray-700 pt-4 text-black">
              <span class="neon-text font-bold">Case.</span> '전기차 화재' 검색량 급증 <br>👉 안전성 강조 보도자료 배포
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-footer border-t border-gray-900">
      <div class="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <div class="md:mb-2">
          <strong class="text-white text-sm">Copyright (C) 2025 업트래닉스. All rights reserved.</strong>
        </div>
        <div class="flex gap-4">
          <!-- <a href="#" class="text-gray-500 hover:text-white text-sm">서비스 이용약관</a> -->
          <a href="https://consumerinsearch.com/privacy" target="_blank" class="text-gray-500 hover:text-white text-sm" style="color: lightgray;">개인정보처리방침</a>
          <a href="https://consumerinsearch.com/#section6" target="_blank" class="text-gray-500 hover:text-white text-sm" style="color: lightgray;">문의하기</a>
        </div>
      </div>
    </section>
  </body>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BSpinner
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { $themeConfig } from "@themeConfig";
import useJwt from "@/auth/jwt/useJwt";

import AuthenticationService from "@/services/authentication.service";
import IntroService from "@/services/cis-intro.service";

import axios from "axios"

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default {
  name: "Login_Test",
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      period: "",

      hot_cat_top_nm: "",
      hot_cat_top_rate: "",
      hot_cat_others: [],

      hot_brand_top_nm: "",
      hot_brand_top_cat_nm: "",
      hot_brand_top_rate: "",      
      hot_brand_others: [],

      hot_prop_top_nm: "",
      hot_prop_top_cat_nm: "",
      hot_prop_top_rate: "",      
      hot_prop_others: [],
    };
  },
  methods: {
    // getStartDateOfLastWeek() {
    //   const today = new Date();
    //   const currentDayOfWeek = today.getDay(); // 0: 일요일, 1: 월요일, ..., 6: 토요일

    //   console.log(currentDayOfWeek);

    //   // 현재 날짜에서 현재 요일까지의 일수를 빼서 이번 주 월요일로 이동
    //   const sundayOfCurrentWeek = new Date(today);
    //   sundayOfCurrentWeek.setDate(today.getDate() - currentDayOfWeek + 1);

    //   console.log(sundayOfCurrentWeek);

    //   // 이번 주 월요일에서 7일을 더 빼서 지난주 월요일로 이동
    //   const sundayOfLastWeek = new Date(sundayOfCurrentWeek);
    //   sundayOfLastWeek.setDate(sundayOfCurrentWeek.getDate() - 7);

    //   console.log(sundayOfLastWeek);

    //   return sundayOfLastWeek;
    // }
    getStartDate() {
      const today = new Date();

      // 현재 날짜에서 현재 요일까지의 일수를 빼서 이번 주 월요일로 이동
      const sundayOfCurrentWeek = new Date(today);
      sundayOfCurrentWeek.setDate(today.getDate() - 1);

      // 이번 주 월요일에서 7일을 더 빼서 지난주 월요일로 이동
      const sundayOfLastWeek = new Date(sundayOfCurrentWeek);
      sundayOfLastWeek.setDate(sundayOfCurrentWeek.getDate() - 7);

      return sundayOfLastWeek;
    }
  },
  setup() {
    console.log('----- setup -----')
    return {}
  },

  async created() {
    console.log('----- created -----')

    // 검색 기간을 설정한다.
    const st_dt = this.getStartDate();
    const en_dt = new Date(st_dt);
    en_dt.setDate(en_dt.getDate() + 6);

    this.period = st_dt.toLocaleDateString('en-CA') + " ~ " + en_dt.toLocaleDateString('en-CA')

    // 전체 카테고리 목록을 가져온다.
    const cat_list = await IntroService.getAllCategory(source);
    const cat_list_data = cat_list.data.data;

    // 전체 카테고리의 지난주 대비 이번주 검색량 변화량을 계산한다.   
    var cat_diff_list = [];
    document.getElementById('loadingCat').style.visibility = "visible";
    document.getElementById('tableCat').style.visibility = "hidden";

    for (var cat_idx = 0; cat_idx < cat_list_data.length; cat_idx++) {
      const cat_item = cat_list_data[cat_idx];

      const diff_rate_resp = await IntroService.getCategorySearchVolTrends({ schema: cat_item.schema, target_dt: en_dt.toLocaleDateString('en-CA') }, source);
      const resp_data = diff_rate_resp.data.data

      console.log(diff_rate_resp)

      if (resp_data.length <= 0)
        continue;

      cat_diff_list.push({'cat_nm': cat_item.name, 'freq': resp_data[0].diffFreq, 'rate': resp_data[0].diffRate})
    }

    document.getElementById('loadingCat').style.visibility = "hidden";
    document.getElementById('tableCat').style.visibility = "visible";

    if (cat_diff_list.length > 0) {
      // 변화량 기준 정렬
      cat_diff_list.sort((a, b) => {
        if (a.freq > b.freq) return -1;
        if (a.freq === b.freq) return 0;
        if (a.freq < b.freq) return 1;
      })

      console.log(cat_diff_list)

      var tmp_cat_diff_list = cat_diff_list.slice(0, 5);

      if (tmp_cat_diff_list.length > 0) { 
        // 변화율 기준 정렬
        tmp_cat_diff_list.sort((a, b) => {
          if (a.rate > b.rate) return -1;
          if (a.rate === b.rate) return 0;
          if (a.rate < b.rate) return 1;
        })

        console.log(tmp_cat_diff_list)

        if (tmp_cat_diff_list[0].rate > 0) {
          this.hot_cat_top_nm = "1. " + tmp_cat_diff_list[0].cat_nm;
          this.hot_cat_top_rate = "+" + tmp_cat_diff_list[0].rate + "%";

          this.hot_cat_others = [];

          for (var idx = 1; idx < tmp_cat_diff_list.length; idx++) {
            if (tmp_cat_diff_list[idx].rate <= 0)
              continue;

            this.hot_cat_others.push({'rank': idx + 1, 'cat_nm': tmp_cat_diff_list[idx].cat_nm, 'rate': tmp_cat_diff_list[idx].rate});

            if (idx > 3)
              break;
          }
        }
        else
          this.hot_cat_top_nm = "empty"
      }
      else 
        this.hot_cat_top_nm = "empty"
    }
    else 
      this.hot_cat_top_nm = "empty"

    var brand_diff_list = [];
    document.getElementById('loadingBrand').style.visibility = "visible";
    document.getElementById('tableBrand').style.visibility = "hidden";

    // 전체 카테고리의 지난주 대비 이번주 브랜드 검색량 변화량을 계산한다.
    for (var cat_idx = 0; cat_idx < cat_list_data.length; cat_idx++) {
      const cat_item = cat_list_data[cat_idx];
      const cat_brand_diff = await IntroService.getBrandSearchVolTrends({ schema: cat_item.schema, target_dt: en_dt.toLocaleDateString('en-CA') }, source)

      console.log(cat_brand_diff)

      const resp_data = cat_brand_diff.data.data;

      if (resp_data.length > 0) {
        for (var idx = 0; idx < resp_data.length; idx++) {
          if (resp_data[idx].diffRate <= 0)
            break;

          brand_diff_list.push({'cat_nm': cat_item.name, 'brand': resp_data[idx].brand, 'freq': resp_data[idx].diffFreq, 'rate': resp_data[idx].diffRate})
        }
      }
    }

    document.getElementById('loadingBrand').style.visibility = "hidden";
    document.getElementById('tableBrand').style.visibility = "visible";

    if (brand_diff_list.length > 0) {
      // 변화량 기준으로 정렬한다.
      brand_diff_list.sort((a, b) => {
        if (a.freq > b.freq) return -1;
        if (a.freq === b.freq) return 0;
        if (a.freq < b.freq) return 1;
      })

      console.log(brand_diff_list)

      var tmp_brand_diff_list = brand_diff_list.slice(0, 5);

      if (tmp_brand_diff_list.length > 0) {
        // 변화율 기준으로 정렬한다.
        tmp_brand_diff_list.sort((a, b) => {
          if (a.rate > b.rate) return -1;
          if (a.rate === b.rate) return 0;
          if (a.rate < b.rate) return 1;
        })

        console.log(tmp_brand_diff_list)

        if (tmp_brand_diff_list[0].rate > 0) {
          this.hot_brand_top_nm = "1. " + tmp_brand_diff_list[0].brand;
          this.hot_brand_top_cat_nm = "(" + tmp_brand_diff_list[0].cat_nm + ")";
          this.hot_brand_top_rate = "+" + tmp_brand_diff_list[0].rate + "%";

          this.hot_brand_others = [];

          for (var idx = 1; idx < tmp_brand_diff_list.length; idx++) {
            if (tmp_brand_diff_list[idx].rate <= 0)
              continue;

            this.hot_brand_others.push({'rank': idx + 1, 'cat_nm': tmp_brand_diff_list[idx].cat_nm, 'brand': tmp_brand_diff_list[idx].brand, 'rate': tmp_brand_diff_list[idx].rate});

            if (idx > 3)
              break;
          }
        }
        else
          this.hot_brand_top_nm = "empty"
      }
      else
        this.hot_brand_top_nm = "empty"
    } 
    else 
      this.hot_brand_top_nm = "empty"

    var prop_diff_list = [];
    document.getElementById('loadingProp').style.visibility = "visible";
    document.getElementById('tableProp').style.visibility = "hidden";

    // 전체 카테고리의 지난주 대비 이번주 브랜드 검색량 변화량을 계산한다.
    for (var cat_idx = 0; cat_idx < cat_list_data.length; cat_idx++) {
      const cat_item = cat_list_data[cat_idx];
      // const cat_prop_diff = await IntroService.getPropSearchVolTrends({ schema: cat_item.schema, target_dt: en_dt.toLocaleDateString('en-CA') }, source) // 속성
      const cat_prop_diff = await IntroService.getPropDetailSearchVolTrends({ schema: cat_item.schema, target_dt: en_dt.toLocaleDateString('en-CA') }, source) // 세부 속성

      console.log(cat_prop_diff)

      const resp_data = cat_prop_diff.data.data;

      if (resp_data.length > 0) {
        for (var idx = 0; idx < resp_data.length; idx++) {
          if (resp_data[idx].diffRate <= 0)
            break;

          // prop_diff_list.push({'cat_nm': cat_item.name, 'prop': resp_data[idx].prop, 'freq': resp_data[idx].diffFreq, 'rate': resp_data[idx].diffRate}) // 속성
          prop_diff_list.push({'cat_nm': cat_item.name, 'prop': resp_data[idx].propDt, 'freq': resp_data[idx].diffFreq, 'rate': resp_data[idx].diffRate}) // 세부 속성
        }
      }
    }

    document.getElementById('loadingProp').style.visibility = "hidden";
    document.getElementById('tableProp').style.visibility = "visible";

    if (prop_diff_list.length > 0) {
      // 변화량 기준으로 정렬한다.
      prop_diff_list.sort((a, b) => {
        if (a.freq > b.freq) return -1;
        if (a.freq === b.freq) return 0;
        if (a.freq < b.freq) return 1;
      })

      console.log(prop_diff_list)

      var tmp_prop_diff_list = prop_diff_list.slice(0, 5);

      if (tmp_prop_diff_list.length > 0) {
        // 변화율 기준으로 정렬한다.
        tmp_prop_diff_list.sort((a, b) => {
          if (a.rate > b.rate) return -1;
          if (a.rate === b.rate) return 0;
          if (a.rate < b.rate) return 1;
        })

        console.log(tmp_prop_diff_list)

        if (tmp_prop_diff_list[0].rate > 0) {
          this.hot_prop_top_nm = "1. " + tmp_prop_diff_list[0].prop;
          this.hot_prop_top_cat_nm = "(" + tmp_prop_diff_list[0].cat_nm + ")";
          this.hot_prop_top_rate = "+" + tmp_prop_diff_list[0].rate + "%";

          this.hot_prop_others = [];

          for (var idx = 1; idx < tmp_prop_diff_list.length; idx++) {
            if (tmp_prop_diff_list[idx].rate <= 0)
              continue

            this.hot_prop_others.push({'rank': idx + 1, 'cat_nm': tmp_prop_diff_list[idx].cat_nm, 'prop': tmp_prop_diff_list[idx].prop, 'rate': tmp_prop_diff_list[idx].rate});

            if (idx > 3)
              break;
          }
        }
        else 
          this.hot_prop_top_nm = "empty"
      }
      else 
        this.hot_prop_top_nm = "empty"
    } 
    else 
      this.hot_prop_top_nm = "empty"
  },

  destroyed() {
    console.log('----- destroyed -----')
  }
};
</script>

<style lang="scss">
  /* @import "@core/scss/vue/pages/page-auth.scss"; */

  body { font-family: 'NanumBarunGothic', sans-serif !important; }

  .neon-text { color: #1817E7; }

  .neon-bg { background-color: #1951DC; }

  .neon-border { border-color: #1817E7; }

  .bg-navy { background-color: #FFFFFF; } /* 슬라이드 배경색 유사 */

  .glass-panel {
    background-color: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.85);
  } 

  *,
  ::before,
  ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: brightness(100%);
    --tw-backdrop-contrast: contrast(100%);
    --tw-backdrop-grayscale: grayscale(100%);
    --tw-backdrop-hue-rotate: hue-rotate(0);
    --tw-backdrop-invert: invert(0%);
    --tw-backdrop-opacity: opacity(100%);
    --tw-backdrop-saturate: saturate(0%);
    --tw-backdrop-sepia: sepia(0%);
    --tw-contain-size: ;
    --tw-contain-layout: ;
    --tw-contain-paint: ;
    --tw-contain-style: ;
  }
  ::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: brightness(100%);
    --tw-backdrop-contrast: contrast(100%);
    --tw-backdrop-grayscale: grayscale(100%);
    --tw-backdrop-hue-rotate: hue-rotate(0);
    --tw-backdrop-invert: invert(0%);
    --tw-backdrop-opacity: opacity(100%);
    --tw-backdrop-saturate: saturate(0%);
    --tw-backdrop-sepia: sepia(0%);
    --tw-contain-size: ;
    --tw-contain-layout: ;
    --tw-contain-paint: ;
    --tw-contain-style: ;
  } /* ! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com */
  *,
  ::after,
  ::before {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: #e5e7eb;
  }
  ::after,
  ::before {
    --tw-content: "";
  }
  :host,
  html {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    -moz-tab-size: 4;
    tab-size: 4;
    font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-feature-settings: normal;
    font-variation-settings: normal;
    -webkit-tap-highlight-color: transparent;
  }
  body {
    margin: 0;
    line-height: inherit;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    text-decoration: inherit;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  pre,
  samp {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      "Liberation Mono", "Courier New", monospace;
    font-feature-settings: normal;
    font-variation-settings: normal;
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    color: inherit;
    margin: 0;
    padding: 0;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  input:where([type="button"]),
  input:where([type="reset"]),
  input:where([type="submit"]) {
    -webkit-appearance: button;
    background-color: transparent;
    background-image: none;
  }
  :-moz-focusring {
    outline: auto;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  progress {
    vertical-align: baseline;
  }
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    height: auto;
  }
  [type="search"] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  summary {
    display: list-item;
  }
  blockquote,
  dd,
  dl,
  figure,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  hr,
  p,
  pre {
    margin: 0 !important;
  }
  fieldset {
    margin: 0;
    padding: 0;
  }
  legend {
    padding: 0;
  }
  menu,
  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0 !important;
  }
  dialog {
    padding: 0;
  }
  textarea {
    resize: vertical;
  }
  input::placeholder,
  textarea::placeholder {
    opacity: 1;
    color: #9ca3af;
  }
  [role="button"],
  button {
    cursor: pointer;
  }
  :disabled {
    cursor: default;
  }
  audio,
  canvas,
  embed,
  iframe,
  img,
  object,
  svg,
  video {
    display: block;
    vertical-align: middle;
  }
  img,
  video {
    max-width: 100%;
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .z-50 {
    z-index: 50;
  }
  .mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .mb-10 {
    margin-bottom: 2.5rem;
  }
  .mb-16 {
    margin-bottom: 4rem;
  }
  .mb-2 {
    margin-bottom: 0.5rem;
  }
  .mb-4 {
    margin-bottom: 1rem;
  }
  .mb-6 {
    margin-bottom: 1.5rem;
  }
  .mb-8 {
    margin-bottom: 2rem;
  }
  .inline-block {
    display: inline-block;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .aspect-video {
    aspect-ratio: 16 / 9;
  }
  .h-12 {
    height: 3rem;
  }
  .h-6 {
    height: 1.5rem;
  }
  .w-12 {
    width: 3rem;
  }
  .w-6 {
    width: 1.5rem;
  }
  .w-full {
    width: 100%;
  }
  .max-w-4xl {
    max-width: 56rem;
  }
  .max-w-5xl {
    max-width: 64rem;
  }
  .max-w-6xl {
    max-width: 72rem;
  }
  .max-w-7xl {
    max-width: 80rem;
  }
  .flex-col {
    flex-direction: column;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-center {
    align-items: center;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .gap-12 {
    gap: 3rem;
  }
  .gap-2 {
    gap: 0.5rem;
  }
  .gap-4 {
    gap: 1rem;
  }
  .gap-6 {
    gap: 1.5rem;
  }
  .gap-8 {
    gap: 2rem;
  }
  .space-y-32 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(8rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(8rem * var(--tw-space-y-reverse));
  }
  .space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: 1rem;
  }
  .rounded-full {
    border-radius: 9999px;
  }
  .rounded-lg {
    border-radius: 0.5rem;
  }
  .rounded-xl {
    border-radius: 0.75rem;
  }
  .border {
    border-width: 1px;
  }
  .border-b {
    border-bottom-width: 1px;
  }
  .border-t {
    border-top-width: 1px;
  }
  .border-gray-700 {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  }
  .border-gray-800 {
    --tw-border-opacity: 1;
    border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
  }
  .bg-black {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
  }
  .bg-footer {
    --tw-bg-opacity: 1;
    background-color: rgb(112 146 190 / var(--tw-bg-opacity, 1));
  }
  .bg-gray-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  }
  .bg-gray-200\/50 {
    background-color: rgb(229 231 235 / 0.5);
  }
  .bg-gray-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
  }
  .bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  }
  .bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
  }
  .to-black {
    --tw-gradient-to: #000 var(--tw-gradient-to-position);
  }
  .p-1 {
    padding: 0.5rem !important;
  }
  .p-4 {
    padding: 1rem;
  }
  .p-6 {
    padding: 1.5rem;
  }
  .p-8 {
    padding: 2rem;
  }
  .px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .pb-2 {
    padding-bottom: 0.5rem;
  }
  .pb-20 {
    padding-bottom: 5rem;
  }
  .pt-32 {
    padding-top: 8rem;
  }
  .pt-4 {
    padding-top: 1rem;
  }
  .text-left {
    text-align: left;
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .font-black {
    font-weight: 900;
  }
  .font-bold {
    font-weight: 700;
  }
  .font-light {
    font-weight: 300;
  }
  .font-medium {
    font-weight: 500;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .leading-relaxed {
    line-height: 1.625;
  }
  .leading-tight {
    line-height: 1.25;
  }
  .tracking-tighter {
    letter-spacing: -0.05em;
  }
  .tracking-widest {
    letter-spacing: 0.1em;
  }
  .text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  }
  .text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1));
  }
  .text-gray-500 {
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1));
  }
  .text-gray-600 {
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity, 1));
  }
  .text-gray-700 {
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1));
  }
  .text-gray-800 {
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity, 1));
  }
  .text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
      var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(4px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness)
      var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale)
      var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert)
      var(--tw-backdrop-opacity) var(--tw-backdrop-saturate)
      var(--tw-backdrop-sepia);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness)
      var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale)
      var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert)
      var(--tw-backdrop-opacity) var(--tw-backdrop-saturate)
      var(--tw-backdrop-sepia);
  }
  .transition {
    transition-property: color, background-color, border-color, fill, stroke,
      opacity, box-shadow, transform, filter, -webkit-text-decoration-color,
      -webkit-backdrop-filter;
    transition-property: color, background-color, border-color,
      text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter,
      backdrop-filter;
    transition-property: color, background-color, border-color,
      text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter,
      backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
  .duration-300 {
    transition-duration: 300ms;
  }
  .hover\:-translate-y-2:hover {
    --tw-translate-y: -0.5rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y))
      rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y))
      scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .hover\:bg-black\/10:hover {
    background-color: rgb(0 0 0 / 0.1);
  }
  .hover\:text-black:hover {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  }
  .hover\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
  .hover\:opacity-90:hover {
    opacity: 0.9;
  }
  @media (min-width: 768px) {
    .md\:mb-0 {
      margin-bottom: 0px;
    }
    .md\:flex {
      display: flex;
    }
    .md\:w-1\/2 {
      width: 50%;
    }
    .md\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .md\:flex-row {
      flex-direction: row;
    }
    .md\:flex-row-reverse {
      flex-direction: row-reverse;
    }
    .md\:text-2xl {
      font-size: 1.5rem;
      line-height: 2rem;
    }
    .md\:text-4xl {
      font-size: 2.25rem;
      line-height: 2.5rem;
    }
    .md\:text-5xl {
      font-size: 3rem;
      line-height: 1;
    }
    .md\:text-6xl {
      font-size: 3.75rem;
      line-height: 1;
    }
  }
  @media (min-width: 1024px) {
    .lg\:pb-32 {
      padding-bottom: 8rem;
    }
    .lg\:pt-48 {
      padding-top: 12rem;
    }
    .lg\:text-7xl {
      font-size: 4.5rem;
      line-height: 1;
    }
  }

  .bubble {
    position: relative;
    background: #28c76f;
    border-radius: 1em;
    color: #fff;
    width: 40px;
    height: 28px;
    text-align: center;
  }

  /* 말풍선 꼬리 만들기 */
  .bubble::after {
    content: '';
    position: absolute;
    top: 9px;
    right: -6px;
    width: 0;
    height: 0;
    border-top-color: #28c76f;
    border-width: 5px 0 5px 6px;
    border-color: transparent #28c76f;
  }

  .bubble_t {
    position: relative;
    background: #28c76f;
    border-radius: 1em;
    color: #fff;
    width: 40px;
    height: 20px;
    text-align: center;
    padding-top: 3px !important;
  }

  /* 말풍선 꼬리 만들기 */
  .bubble_t::after {
    content: '';
    position: absolute;
    top: 6px;
    left: -5px;
    width: 0;
    height: 0;
    border-top-color: #28c76f;
    border-width: 4px 6px 4px 0;
    border-color: transparent #28c76f;
  }

</style>
